module.exports = __webpack_public_path__ + "static/media/plane.770c7a75.svg";